import { arSD, enUS, esES, frFR, GridLocaleText } from "@mui/x-data-grid"
import { LOCALES } from "app/language/model"
import { languageSVC, translate } from "app/language/service"
import { LIST_SORT_DIRECTIONS } from "ui/model"

export function stableSort<T>(array: T[], comparator: (a: T, b: T) => number): T[] {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

export function getSortComparator<Key extends keyof any>(
  order: LIST_SORT_DIRECTIONS,
  orderBy: Key
): (a: { [key in Key]: number | string | Date | null }, b: { [key in Key]: number | string | Date | null }) => number {
  return order === LIST_SORT_DIRECTIONS.DESC
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export function getDataGridTexts(noRowKey?: string): Partial<GridLocaleText> {
  if (noRowKey) {
    switch (languageSVC.getLocale()) {
      case LOCALES.EN: {
        return {
          ...enUS.components.MuiDataGrid.defaultProps.localeText,
          noRowsLabel: translate(noRowKey)
        }
      }
      case LOCALES.FR: {
        return {
          ...frFR.components.MuiDataGrid.defaultProps.localeText,
          noRowsLabel: translate(noRowKey)
        }
      }
      case LOCALES.ES: {
        return {
          ...esES.components.MuiDataGrid.defaultProps.localeText,
          noRowsLabel: translate(noRowKey)
        }
      }
      case LOCALES.AR: {
        return {
          ...arSD.components.MuiDataGrid.defaultProps.localeText,
          noRowsLabel: translate(noRowKey)
        }
      }
      default: {
        throw Error(`Language "${languageSVC.getLocale()}" not supported`)
      }
    }
  }
  switch (languageSVC.getLocale()) {
    case LOCALES.EN: {
      return enUS.components.MuiDataGrid.defaultProps.localeText
    }
    case LOCALES.FR: {
      return frFR.components.MuiDataGrid.defaultProps.localeText
    }
    case LOCALES.ES: {
      return esES.components.MuiDataGrid.defaultProps.localeText
    }
    case LOCALES.AR: {
      return arSD.components.MuiDataGrid.defaultProps.localeText
    }
    default: {
      throw Error(`Language "${languageSVC.getLocale()}" not supported`)
    }
  }
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}
